module.exports = __webpack_public_path__ + "img/bet500.8e9f39d0.png";